<template>
     <div class="main">
        <div class="wrap">
        <div class="person_text_info">
            <div class="person_text">
                <div class="person">
                    <img src="../../assets/img/share.png" alt="">
                </div>
                <div class="person_text_info_txt">
                    <div class="text_top">恭喜您</div>
                    <div class="text_bottom">获得线上掌柜！</div>
                </div>
            </div>
        </div>
        
        <div class="box">
            <div class="box_details">
                <div class="photo">
                    <img :src="FreeChargeShare.headImg" alt="">
                </div>
                <div class="text_1">
                    <span class="text_1_1">已免</span>
                    <span class="text_1_2">{{FreeChargeShare.freeSN}}</span>
                    <span class="text_1_3">单</span>
                </div>
                <div class="text_2">
                    <span class="text_2_1">本次支付的</span>
                    <span class="text_2_2">￥{{FreeChargeShare.freeAmount}}</span>
                    <div></div>
                </div>
                <div class="text_3">
                    将直接退到您支付的账号中
                </div>
                <div class="text_4" @click="goto">
                    <div class="text_4_1">活动规则</div>
                    <div class="text_4_2"><img src="../../assets/img/icon1.png" alt=""></div>
                </div>
            </div>
        </div>
    </div>
      <!-- 底部 -->
      <div class="bottom_wrap">
        <div class="bottom">
            <div class="bottom_con">
                <div class="bottom_left">
                    <div class="share_img">
                        <img src="../../assets/img/logo.png" alt="">
                    </div>
                    <div class="share_des">
                        <p>线上掌柜</p>
                        <p>新人注册有红包</p>
                    </div>
                    <div class="clear"></div>
                </div>
                <div class="bottom_right" @click="goDownload">
                    <div>立刻加入</div>
                </div>
                <div class="clear"></div>
            </div>
        </div>
    </div>
    </div>
</template>
<script>
import { Toast} from 'vant';
import { freeshareorderModule } from "../../request/myFreecharge";
export default {
    data(){
        return{
            FreeChargeShare:{},
            explainContent:'',
            explainTitle:''
        }
    },
    created:async function(){
        await this.freeshareorder()
        // this.getInfo()
    },
    methods:{
        async freeshareorder(){
            //  this.$route.query.orderID=2
             await freeshareorderModule.freeshareorder(this.$route.query.orderID).then((response) => {
                console.log(response)
               switch(response.data.code){
                    case 100:
                         {
                             this.FreeChargeShare=response.data.result
                              console.log(response.data.result)              
                         }
                        break;
                    case 101:
                        break;
                    case 102:
                        Toast.clear();
                        break;
                    case 100001:
                        // Toast.clear();
                        // Toast({
                        //     message: '网络连接异常',
                        //     position: 'center',
                        // });
                        break;
                }
            }).catch(()=>{})
        },
        goto(){
            this.$router.push({
                path:'/about',
                query:{
                    explainID:19,
                }
            })
        },
        // async getInfo(){
        //     await explainsettingModule.explainsettingdetailshare(19).then((response)=>{
        //         // console.log(response)
        //         switch (response.data.code) {
        //             case 100:
        //                 this.explainContent = response.data.result.explainContent
        //                 this.explainTitle = response.data.result.explainTitle
        //                 break;
        //             case 101:
        //                 Toast({
        //                     message: "获取失败",
        //                     position: 'center',
        //                 });
        //                 break;
        //             case 100001:
        //                 Toast({
        //                     message: "网络接连异常，请稍后再试",
        //                     position: 'center',
        //                 });
        //                 break;
        //         }
        //     }).catch(()=>{})
        // },
        goDownload(){
            this.$router.push({
                path:'/download',
                query:{
                    marktype:1,
                }
            })
        },
    }
}
</script>
<style scoped>
/* 我的免单 分享页面 */
.main{
    height: 100%;
    background: linear-gradient(180deg,#ff5457, #f90909);
}
.wrap{
    height: 100%;
}
.person_text{
    display: flex;
    justify-content: center;
    
}
.person{
    font-size: 0;
}
.person img{
    width: 3.133rem;
    height: 4.01rem;
    margin-left: 0.13rem;
    margin-top: 2.293rem;
}
.person_text_info_txt{
    display: flex;
    flex-direction: column;
    /* margin-left: 5.226rem;
    margin-top: -2.42rem; */
    margin: 0;
}
.person_text_info_txt div{
    color: #FAFAFA;
    font-size: 0.48rem;
    font-weight: bold;
    line-height: 0.96rem;
}
.person_text_info_txt > .text_top{
    margin-top: 3.85rem;
}
.box_details{
    background-color: #FFFFFF;
    width: 8.72rem;
    height: 8.506rem;
    border-radius: 0.4rem;
    /* margin-left: 0.64rem;
    margin-top: 0.42rem; */
    margin: 0 auto;
    text-align: center;
}
/* 白色盒子部分 */
.box{
    display: flex;
    justify-content: center;
}
.box  .box_details  .photo{
    display: flex;
    justify-content: center;
}
.box  .box_details  .photo img{
    width: 1.6rem;
    height: 1.6rem;
    border-radius: 50%;
    margin-top: 0.8rem;
}
.box  .box_details  .text_1{
    margin-top: 0.8rem;
}
.box  .box_details  .text_1  .text_1_1{
    font-size: 0.426rem;
    color: #323232;
    font-weight: Medium;
}
.box  .box_details  .text_1  .text_1_2{
    font-size: 0.693rem;
    color: #FF0000;
    font-weight: bold;
}
.box  .box_details  .text_1  .text_1_3{
    font-size: 0.426rem;
    color: #323232;
    font-weight: Medium;
}
.box  .box_details > .text_2  .text_2_1{
    font-size: 0.388rem;
    color: #323232;
    font-weight: Medium;
}
.box  .box_details  .text_2{
    display: flex;
    justify-content: center;
    margin-top: 0.8rem;
}
.box  .box_details  .text_2  .text_2_2{
    font-size: 0.388rem;
    color: #FF0000;
    font-weight: bold;
}
.box  .box_details  .text_3{
    display: flex;
    justify-content: center;
    margin-top: 0.3rem;
    font-size: 0.388rem;
    color: #323232;
    font-weight: Medium;   
}
.box  .box_details  .text_4{
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 0.4rem;
}
.box  .box_details  .text_4  .text_4_1{
    font-size: 0.373rem;
    color: #FF0000;
    font-weight: Medium;
}
.box  .box_details  .text_4  .text_4_2{
    display: flex;
    align-items: center;
}
.box  .box_details  .text_4  .text_4_2 img{
    margin-left: 0.266rem;
    width: 0.426rem;
    height: 0.426rem;
}


</style>